let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("kXAv1")).then(() => parcelRequire('dCIBj'));